import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SeoToolsApiService {

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  checkSeo(url: string, toolType: number) {
    return this.httpClient.get(this.baseUrl + 'seoTools/checkSeo?url=' + encodeURIComponent(url) + "&toolType=" + toolType);
  }
}
